import React from "react";
import { Navigate, useParams } from "react-router";
import { useSetups } from "../../api/useSetups";
import { useQuantities } from "../../api/useQuantities";
import { useMemo } from "react";

export const ProjectNavigate = () => {
  const { projectId } = useParams();

  if (!projectId) return null;
  return <NavigateDefault projectId={projectId} />;
};

const NavigateDefault = ({ projectId }: { projectId: string }) => {
  const setups = useSetups(projectId);
  const quantities = useQuantities(projectId);
  const hasPerformanceIndicators = useMemo(
    () => quantities.filter(q => q.qoiOrder !== null).length > 0,
    [quantities],
  );

  if (setups.length === 0) return <Navigate to={`/projects/${projectId}/measures`} replace />;

  if (!hasPerformanceIndicators)
    return <Navigate to={`/projects/${projectId}/diagnosis`} replace />;

  return <Navigate to={`/projects/${projectId}/summary`} replace />;
};
